import React, { useState, useEffect } from 'react';
import { Spin, Alert } from 'antd';

const TextFilePreview = ({ fileUrl }) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTextContent = async () => {
      try {
        setLoading(true);
        const response = await fetch(fileUrl);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const text = await response.text();
        setContent(text);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (fileUrl) {
      fetchTextContent();
    }
  }, [fileUrl]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <Spin size="large" />
        <p style={{ marginTop: '16px', color: '#666' }}>Loading text file...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '20px' }}>
        <Alert
          message="Error loading text file"
          description={error}
          type="error"
          showIcon
        />
      </div>
    );
  }

  return (
    <div style={{ 
      padding: '20px', 
      maxHeight: '400px', 
      overflowY: 'auto',
      fontFamily: 'monospace',
      fontSize: '14px',
      lineHeight: '1.5',
      backgroundColor: '#fafafa',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word'
    }}>
      {content || 'No content to display'}
    </div>
  );
};

export default TextFilePreview;